import { Heading, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { Card } from '../../../components';
import { useEventId } from '../../../hooks';
import { ShareablesSection } from './ShareablesSection';
import { getShareables } from './ShareablesContent';

export const Shareables: FC = (): JSX.Element => {
  const eventId = useEventId();
  const sharables = getShareables(eventId);

  return (
    <Card>
      <Heading size="md" color="brand.primary.swatch1" mb="1rem">
        St. Jude Shareables
      </Heading>
      <Text mb="1rem">
        Looking for ways to promote your fundraiser? Here are some easy-to-share
        images to help you promote your fundraiser and ask for donations from
        friends and family.
      </Text>
      <ShareablesSection
        images={sharables.images}
        moreSizesUrl={sharables.moreSizesUrl}
      />
    </Card>
  );
};
